import { useCallback, useEffect, useState } from 'react';
import { listTickets } from 'api/tickets';

const PAGE_SIZE = 25;

export default function useTicketsList(initialFilters = {}) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState(initialFilters);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await listTickets({
        ...filters,
        search: search || undefined,
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
      });
      setRows(Array.isArray(data?.rows) ? data.rows : []);
      setTotal(data?.total ?? 0);
    } catch {
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [filters, search, page]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    rows,
    total,
    loading,
    page,
    setPage,
    pageSize: PAGE_SIZE,
    search,
    setSearch,
    filters,
    setFilters,
    refresh,
  };
}
